import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';

export interface ICardSlideMeta {
    x: number;
    y: number;
    rotation: number;
    duration: number;
}

export class CardSlide extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: ICardSlideMeta
    ): IterableIterator<number> {
        meta.duration = meta.duration || 150;

        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const tweenPosition = this.getTween(transform.position);
        const tweenRotation = this.getTween(transform);

        tweenPosition
            .to(
                {
                    x: meta.x,
                    y: meta.y,
                },
                meta.duration
            )
            .easing(Easing.Quadratic.Out)
            .start(this.elapsedTime);

        if (meta.rotation) {
            tweenRotation
                .to(
                    {
                        rotation: meta.rotation,
                    },
                    meta.duration
                )
                .easing(Easing.Quadratic.Out)
                .start(this.elapsedTime);
        }

        yield* this.startTween(tweenPosition);
    }
}
